import useMounted from '@restart/hooks/useMounted';
import { useRef } from 'react';
import useLocalTransform from './useLocalTransform';
export function useThrottledPointerMove(isActive, onMove) {
  const transform = useLocalTransform();
  const isMounted = useMounted();
  const nextPointRef = useRef({
    point: null,
    handle: null
  });

  const cancel = () => {
    cancelAnimationFrame(nextPointRef.current.handle);
    nextPointRef.current.handle = null;
  };

  const handlePointerMoveAnimation = () => {
    const {
      current: next
    } = nextPointRef;

    if (next.handle && next.point) {
      next.handle = null;
      onMove(next.point);
    }

    next.point = null;
  };

  const handlePointerMove = event => {
    if (!isActive(event) || !isMounted()) return;
    nextPointRef.current.point = transform.getPointFromEvent(event.evt);

    if (!nextPointRef.current.handle) {
      nextPointRef.current.handle = requestAnimationFrame(handlePointerMoveAnimation);
    }
  };

  return [handlePointerMove, cancel];
}